<!--
Moves background task alert containers to a specific mount point in Vue pages.
This allows positioning alerts differently than the default background_task_status.html.slim partial.
-->
<template>
  <div class="background-task-mount-point"></div>
</template>

<script>
export default {
  mounted() {
    const mountPoint = this.$el;

    this._movedNodes = [];

    const moveContainers = (containers) => {
      containers.forEach((container) => {
        if (!(container instanceof HTMLElement)) {
          return;
        }

        if (mountPoint.contains(container)) {
          return;
        }

        this._movedNodes.push({
          node: container,
          parent: container.parentNode,
          nextSibling: container.nextSibling,
        });

        mountPoint.appendChild(container);
        requestAnimationFrame(() => {
          container.classList.replace('invisible', 'visible');
        });
      });
    };

    // Move all background task containers to the mount point so they are placed above list
    moveContainers(document.querySelectorAll('.background-task-status'));

    this._observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) {
            return;
          }

          if (node.classList.contains('background-task-status')) {
            moveContainers([node]);
          } else {
            const nested = node.querySelectorAll?.('.background-task-status');

            if (nested?.length) {
              moveContainers(nested);
            }
          }
        });
      });
    });

    this._observer.observe(document.body, { childList: true, subtree: true });
  },
  beforeDestroy() {
    if (Array.isArray(this._movedNodes)) {
      this._movedNodes.forEach(({ node, parent, nextSibling }) => {
        if (!parent) {
          return;
        }
        if (nextSibling && parent.contains(nextSibling)) {
          parent.insertBefore(node, nextSibling);
        } else {
          parent.appendChild(node);
        }
      });
    }

    if (this._observer) {
      this._observer.disconnect();
    }
  },
};
</script>
